import { useParams } from 'react-router-dom'
import { Card } from '../styled'

export default function VideoCard({ title, text, imageCaption, imageSource, onClick }) {
  const { id: selectedVideoId } = useParams()

  return (
    <Card withHover onClick={onClick}>
      <Card.ImageWrapper flexBasis={!!selectedVideoId ? '50%' : '30%'}>
        <Card.Image src={imageSource} alt={title} />
        <Card.ImageCaption visible={!!imageCaption}>{imageCaption}</Card.ImageCaption>
      </Card.ImageWrapper>
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text>{text}</Card.Text>
      </Card.Body>
    </Card>
  )
}
